import React from 'react';
import { Note, getNotePhotoUrl } from '../api/client';

interface Props {
  note: Note | null;
  isOpen: boolean;
  onClose: () => void;
}

export function ViewNoteModal({ note, isOpen, onClose }: Props) {
  if (!isOpen || !note) return null;

  const photoUrl = getNotePhotoUrl(note.photo_url);

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div
      onClick={handleBackdropClick}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
        padding: '16px'
      }}
    >
      <div style={{
        background: '#fff',
        borderRadius: '8px',
        width: '100%',
        maxWidth: '500px',
        maxHeight: '90vh',
        overflow: 'auto',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)'
      }}>
        {/* Header */}
        <div style={{
          padding: '16px 20px',
          borderBottom: '1px solid #eee',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <h2 style={{ margin: 0, fontSize: '18px' }}>Note</h2>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '24px',
              cursor: 'pointer',
              color: '#666',
              padding: '0 4px'
            }}
          >
            &times;
          </button>
        </div>

        {/* Body */}
        <div style={{ padding: '20px' }}>
          {photoUrl && (
            <div style={{ marginBottom: '16px' }}>
              <img
                src={photoUrl}
                alt="Note attachment"
                style={{
                  width: '100%',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
                onClick={() => window.open(photoUrl, '_blank')}
              />
              <p style={{ 
                margin: '8px 0 0', 
                fontSize: '12px', 
                color: '#666',
                textAlign: 'center'
              }}>
                Tap image to view full size
              </p>
            </div>
          )}

          <div style={{
            padding: '16px',
            background: '#f8f9fa',
            borderRadius: '4px',
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word'
          }}>
            {note.content}
          </div>

          <div style={{
            marginTop: '16px',
            color: '#666',
            fontSize: '13px'
          }}>
            <span style={{ fontWeight: 500 }}>{note.author_name}</span>
            <span style={{ margin: '0 8px' }}>&bull;</span>
            <span>{formatDate(note.created_at)}</span>
          </div>
        </div>

        {/* Footer */}
        <div style={{
          padding: '16px 20px',
          borderTop: '1px solid #eee',
          display: 'flex',
          justifyContent: 'flex-end'
        }}>
          <button
            onClick={onClose}
            style={{
              padding: '10px 24px',
              background: '#007bff',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '14px'
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}